export {
  getSmartPageUrlSuffix,
  getInstrumentationKeyByEnv,
  SmartPageUrlSuffix,
} from './src/smart-page-url-suffix-provider';
